import { useState } from "react";
import { entryChannels } from "@/mocks/homeData";

export default function EntryChannels() {
  const [copied, setCopied] = useState("");

  const handleCopy = async (value: string, id: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(id);
      window.setTimeout(() => setCopied(""), 1800);
    } catch {
      setCopied(id);
      window.setTimeout(() => setCopied(""), 1800);
    }
  };

  return (
    <section id="channels" className="w-full bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-links-line"></i>
              <span>官方入口速达</span>
            </div>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              黑料官方直达入口，一屏看全
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              客服、投稿、通知、下载都放在这里。认准本页整理的黑料官方入口，
              点一下就能进入对应通道，不用再靠搜索绕远路。
            </p>
          </div>
          <span className="shrink-0 hidden md:inline-flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-refresh-line"></i>
            入口每日校检，保持可用
          </span>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {entryChannels.map((item) => (
            <article
              key={item.id}
              className={`group relative flex flex-col rounded-lg border p-5 md:p-6 transition-colors ${
                item.highlight
                  ? "border-primary-300 bg-primary-50"
                  : "border-background-200/80 bg-background-50 hover:border-primary-200"
              }`}
            >
              {item.highlight && (
                <span className="absolute top-4 right-4 text-[11px] font-medium text-primary-700 bg-primary-100 px-2 py-0.5 rounded-full">
                  官方推荐
                </span>
              )}

              <span
                className={`w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center text-2xl ${
                  item.highlight ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                }`}
              >
                <i className={item.icon}></i>
              </span>

              <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>

              <div className="mt-4 flex items-center justify-between gap-3 border-t border-background-200/70 pt-4">
                <span className="text-xs md:text-sm text-foreground-700 truncate">{item.value}</span>
                {item.id === "mail" ? (
                  <button
                    type="button"
                    onClick={() => handleCopy(item.value, item.id)}
                    className="shrink-0 inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
                  >
                    <i className={copied === item.id ? "ri-check-line" : "ri-file-copy-line"}></i>
                    <span>{copied === item.id ? "已复制" : item.action}</span>
                  </button>
                ) : (
                  <a
                    href="#contact"
                    className="shrink-0 inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
                  >
                    <span>{item.action}</span>
                    <i className="ri-arrow-right-line"></i>
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 md:mt-8 text-xs md:text-sm text-foreground-500 flex items-start gap-2">
          <i className="ri-information-line shrink-0 mt-0.5"></i>
          <span>
            官方不会通过任何渠道索要费用或验证码。如遇无法核实的地址，请先通过官方客服邮箱确认后再操作。
          </span>
        </p>
      </div>
    </section>
  );
}